import Cookies from 'js-cookie';
import 'sticksy';

const handler = ( $ ) => {
	$(document).on( 'click', '#ajax-load-more, a.ajax-load-more-link', function ( e ) {
		e.preventDefault();

		const $link = $( this ),
		$postsHolder = $( $link.data( 'posts-holder' ) ),
		$articles = $postsHolder.find( 'article' ),
		post_type = $link.attr( 'data-post-type' );

		let offset = $articles.length,
		loadedIDs = [];

		if( $articles.length ) {
			$articles.each( function() {
				loadedIDs.push( $(this).data('id') );
			});
		}

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'fp_load_posts',
				query: $link.attr( 'data-current-query' ),
				post_type: post_type,
				offset: offset,
				loadedIDs: loadedIDs,
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
			},
			beforeSend: function () {
				$link.addClass( 'is-loading' );
				$postsHolder.addClass( 'is-loading' );
			},
			success: function ( answer ) {
				$link.removeClass( 'is-loading' );
				$postsHolder.removeClass( 'is-loading' ).append( answer.html );

				$link.attr(
					'data-current-query',
					JSON.stringify( answer.query )
				);

				if ( answer.hide_link ) {
					$link.hide();
				} else {
					$link.show();
				}

				if( post_type == 'user' ) {
					$('#members-directory-filters .loaded-posts-num').html( $('#posts').find('article').length);
				}

				$('body').trigger('fp_ajax_pagination_loaded');

			},
		} );
		
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
